import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import i18n from 'i18next';
import { siteTheme, languagesInfo, siteConfig, brandColors } from '../variables/config'
import TLink from '../components/TLink.jsx'
import * as actions from '../stores/actionsList';
import { translate, checkTextTranslation } from '../utils/useful'
import routes from '../variables/routes';
import { withRouter } from 'react-router-dom';
import FixedView from './FixedView';
import history from '../utils/history';
import Loader from 'react-loader-spinner';
import HttpServices from '../utils/Http.services';
import { addTopic } from '../utils/socket.services';
import Cookies from "universal-cookie";
import { nanoid } from 'nanoid';
import { getBoundingClientRect } from '../utils/functions';


class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            MoileMenu: false,
            inbox: [],
            inboxId: nanoid(),
            inboxColors: {
                create: { pri: 'rgb(0, 201, 167)', sec: 'rgb(0, 205, 116)' },
                update: { pri: 'rgb(0, 160, 201)', sec: 'rgb(0, 116, 205)' },
                remove: { pri: brandColors.danger, sec: '#ef4444' },

            }
        }
        // this.inboxBut = React.createRef();
    }



    componentDidMount() {
        const cookies = new Cookies();
        let token = cookies.get('admintoken');
        if (token) {
            this.waitForId(10)
        }
        // setTimeout(() => {
        this.setState({ show: true })
        // }, 100);

        setInterval(() => {
            //     console.log("_---_")

            //     if(this.inboxBut){
            //         let viewRect = getBoundingClientRect(this.inboxBut)

            //         console.log(viewRect.left)

            //     }

            // this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: "TEST" })

        }, 1000);
    }

    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            // this.fetchInbox()
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                }
            }, 500);
        }
    }


    fetchInbox() {

        this.setState({ isLoadingInbox: true })

        HttpServices.request('getInbox', {limit:20, filter: { opened: false } }, (fetchResult, fetchError, fetchStatus) => {
            // console.log(fetchResult)
            // console.log(fetchError)

            addTopic(this.state.inboxId, 'activities', 'admin', null, this.updateInbox)

            this.setState({ isLoadingInbox: false })
            if (fetchError) {
                // this.setState({ pageStatus: fetchStatus })
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}erd', description: fetchError.message })
                return
            }

            this.setState({ inbox: fetchResult.info }, () => {
                this.calcNoficCount()
            })


            // addTopic(this.state.inboxId, this.props.user?.info?._id, 'users', null, this.updateInbox)

        })
    }


    notifSeen = (id) => {
        console.log("notifSeen")
        HttpServices.request('seenInbox', { id }, (fetchResult, fetchError, fetchStatus) => {
           
            console.log(fetchError)

            console.log(fetchResult)
            if (fetchError) {
                return
            }

            let inbox = this.state.inbox
            inbox.forEach(element => {
                if (element._id == id) {
                    element.opened = true
                }
            });

            this.setState({ inbox }, () => {
                this.calcNoficCount()
            })


        })

    }

    calcNoficCount = () => {
        let count = 0
        let inbox = this.state.inbox
        inbox.forEach(element => {
            if (!element.opened) {
                count++
            }
        });

        if(count==20){
            count = "+20"
        }

        this.setState({ notifCount: count })
    }


    updateInbox = (newData) => {

        console.log("updateInbox")

        let inbox = this.state.inbox
        inbox.splice(0, 0, newData)
        this.setState({ inbox }, () => {
            this.calcNoficCount()
        })
        this.props.actions.addNotif({ type: 'notification', title: newData.type, description: newData.message })

    }



    changeLanguage = (key, value) => {
        i18n.changeLanguage(value)
        this.closeBox()
    }

    countCart() {
        let count = 0
        if (this.props.cart) {
            Array.isArray(this.props.cart.items) && this.props.cart.items.forEach(element => {
                count += element.count
            });
        }
        return count
    }


    checkssion(page, reference) {
        if (!page.roles) {
            return true
        }
        if (reference.info) {
            for (let i = 0; i < page.roles.length; i++) {
                const oneRole = page.roles[i];
                if (oneRole.role === reference.info.role) {
                    return true
                }
            }
        }
    }


    toggleLanguagesBox() {
        if (!this.state.showLanguagesBox) {
            document.addEventListener('mousedown', this.closeBox);
            this.setState({ showLanguagesBox: true })
        } else {
            this.closeBox()
        }
    }

    closeBox = (event) => {
        if (!event || (this.language_select_box && !this.language_select_box.contains(event.target))) {
            document.removeEventListener('mousedown', this.closeBox);
            let box = document.querySelectorAll('.language-select-box')
            if (box) {
                box[0].classList.add('fadeout')
            }

            setTimeout(() => {
                this.setState({ showLanguagesBox: false })
            }, 400);
        }
    }


    openInbox = () => {
        if (this.inboxFixedView) {
            this.inboxFixedView.showView()
        }
        // console.log(this.inboxBut)
    }


    setRef = (el, name) => {
        this[name] = el
    }


    render() {


        if (this.state.show) {

            return (
                <header className="header w-100" style={{ color: siteTheme.themeColors.headerFont, position: this.props.settings?.fixedHeader ? "fixed" : 'sticky', top: 0, left: 0, width: '100%', zIndex: 10, borderBottom: this.props.settings?.headerBackground ? "" : '#e6eaf2 solid 1px' }}>
                    <div className="flexcb blur-back w-100" style={{ background: siteTheme.themeColors.headerBack + 'dd', backgroundImage: this.props.settings?.headerBackground, color: this.props.settings?.headerTextColor ?? "#101010", height: 45, padding: '5px 15px' }}>
                        <div className="flexcc">
                            {!this.props.settings?.showTabBar && (
                                <TLink pathname='/' className="flexcc mrd-4">
                                    <img className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : ''} src={siteTheme.logo_s} height="30px" alt={siteConfig.name + ' logo'} />
                                </TLink>
                            )}
                            <div className="flexc">
                                {this.props.settings?.button?.goBack && (
                                    <button className="h-100 reverse flexcc  py-0" onClick={() => history.goBack()}>
                                        <img src="/images/next.png" style={{ width: 18 }} alt="" />
                                    </button>
                                )}

                                {Array.isArray(this.props.settings?.titleButtons) && (
                                    this.props.settings?.titleButtons.map((prop, index) => {
                                        return (
                                            <div key={index}>
                                                {prop}
                                            </div>
                                        )
                                    })
                                )}

                                <div className="d-flex flex-column justify-content-center w-100" style={{ overflow: 'hidden' }}>

                                    {this.props.settings?.headerTitlePrefix && (<p className="text-smaller mb-0 mt-2" style={{ lineHeight: 0.3, opacity: 0.8 }}>{this.props.settings?.headerTitlePrefix}</p>)}
                                    <p className="text-semibig font-bold" style={{ whiteSpace: 'nowrap' }}>{this.props.settings?.headerTitle}</p>
                                </div>





                            </div>
                            {/* 3a84da */}

                            <div className='flexcc d-none d-lg-flex'>
                                {routes.map((prop, index) => {
                                    if (prop.header) {
                                        if (this.checkPermission(prop, this.props.user)) {
                                            return (
                                                <nav key={index} className="mld-10 cursor-pointer text-normal">
                                                    <TLink pathname={prop.pathForHeader ? prop.pathForHeader : prop.path}>{checkTextTranslation(prop.name)}</TLink>
                                                </nav>
                                            )
                                        }
                                    } else {
                                        return
                                    }
                                })}
                            </div>

                        </div>


                        <div className="flexcc">


                            {Array.isArray(this.props.settings?.headerButtons) && (
                                this.props.settings?.headerButtons.map((prop, index) => {
                                    console.log("UPDATE")
                                    return (
                                        <div key={index}>
                                            {prop}
                                        </div>
                                    )
                                })
                            )}


                            {!this.props.settings?.hideProfileButton && !this.props.user?.loggedin && siteConfig.showProfile && (
                                <div className="mrd-3">
                                    {/* <TLink pathname='/login' className=" text-small cursor-pointer" style={{ padding: '2px 20px', borderRadius: 40, backgroundColor: siteTheme.themeColors.headerFont + '10', border: '#ffffff30 0px solid' }}>{translate('login')}</TLink> */}
                                    <TLink pathname='/login' className=" text-small cursor-pointer p-0 flexcc" style={{}}><img src="https://image.flaticon.com/icons/svg/2948/2948035.svg" className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : ''} height="24px" /></TLink>

                                </div>
                            )}

                            {!this.props.settings?.hideProfileButton && this.props.user?.loggedin && siteConfig.showProfile && (
                                <div className="mrd-3">
                                    {/* <TLink pathname='/me' className=" text-small cursor-pointer" style={{ padding: '2px 20px', borderRadius: 40, backgroundColor: siteTheme.themeColors.headerFont + '10', border: '#ffffff30 0px solid' }}>{translate('profile')}</TLink> */}
                                    <TLink pathname='/profile' className=" text-small cursor-pointer p-0 flexcc" style={{}}><img src="/images/user.png" className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : ''} height="24px" /></TLink>

                                </div>
                            )}

                            {/* {siteConfig.showCart && (
                            <TLink pathname='/checkout' className="flexcc mld-4">
                                <div className="position-relative flexcc">

                                    <img className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : ''} src="https://image.flaticon.com/icons/svg/1374/1374128.svg" height="20px" alt="" />

                                    {this.countCart() > 0 && (
                                        <div className="flexcc position-absolute" style={{ top: 0, left: 10, backgroundColor: brandColors.primary, borderRadius: 30, minWidth: 20, height: 20, fontSize: 14 }}>
                                            <span>{this.countCart()}</span>
                                        </div>
                                    )}
                                </div>
                            </TLink>
                        )} */}

                            <button onClick={() => this.openInbox()} ref={el => this.inboxBut = el} className="flexcc mrd-4 mld-2 p-0">
                                <div className="position-relative flexcc">

                                    <img className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : ''} src="/images/notification.svg" height="22px" alt="" />
                                    {(this.state.notifCount > 0) && (
                                        <div className="flexcc position-absolute white" style={{ top: 0, left: 10, backgroundColor: brandColors.primary, borderRadius: 30, minWidth: 20, height: 20, fontSize: 14 }}>
                                            <span>{this.state.notifCount}</span>
                                        </div>
                                    )}
                                </div>
                            </button>


                            {this.inboxBut && (
                                <FixedView zIndex={1} ref={el => this.inboxFixedView = el} nodeRef={this.inboxBut}   >
                                    <div className="blur-back ml-0  flexcc flex-column" style={{ color: '#000510', zIndex: 1, boxShadow: '0px 0px 15px #00000010', backgroundColor: '#ffffffdd', borderRadius: 8, marginTop: 40, width: 300 }}>
                                        <div className="py-2 px-2 w-100" style={{ backgroundImage: 'linear-gradient(#3869f4,#3362e5)', borderRadius: '4px 4px 0px 0px' }}>
                                            <p className="text-normal tex-uppercase text-bold px-2 white">Inbox</p>
                                        </div>
                                        <div className="py-2 w-100" style={{ maxHeight: 300, overflow: 'auto' }}>


                                            {this.state.isLoadingInbox && (
                                                <div className="flexcc mt-2 mb-2">
                                                    <Loader
                                                        type={"ThreeDots"}
                                                        color={"#789"}
                                                        height={20}
                                                        width={50}
                                                    />
                                                </div>
                                            )}

                                            {!this.state.isLoadingInbox && this.state.inbox.length == 0 && (
                                                <div className="text-center p-2 my-2">
                                                    <p className="text-normal">Nothing to show!</p>
                                                </div>
                                            )}

                                            {!this.state.isLoadingInbox && this.state.inbox.map((prop, index) => {
                                                return (
                                                    <TLink to={prop.url ?? ''} key={index}>
                                                        <div className="w-100 px-3 flexc text-start mb-2" onClick={() => this.notifSeen(prop._id)} style={{ opacity: prop.opened ? '0.5' : '1' }} >
                                                            <div className="flexcc" style={{padding:'4px',height:30,width:30, borderRadius:30, background: 'linear-gradient(' + this.state.inboxColors[prop.type]?.pri + ',' + this.state.inboxColors[prop.type]?.sec + ')' }}>
                                                                <img className="invert" src={'/images/actions/' + prop.type + '.svg'} width="26px" />
                                                            </div>
                                                            <div className="mld-4">
                                                                <p className="text-small text-bold">{prop.title}</p>
                                                                <p className="text-smaller">{prop.message}</p>
                                                            </div>
                                                        </div>
                                                    </TLink>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </FixedView>
                            )}



                            {/* {siteConfig.showLanguage && (
                            <div className="flexcc mld-4">

                                {languagesInfo[this.props.settings?.language] && (
                                    <div className="d-none d-lg-block" style={{ position: 'relative', }}>
                                        <button onClick={() => this.toggleLanguagesBox()} className="flexcc language-but">
                                            <img className="" src={languagesInfo[this.props.settings?.language].icon} height="20px" alt="" />
                                            <span className=" mld-2" style={{ color: siteTheme.themeColors.headerFont }}>{languagesInfo[this.props.settings?.language].name}</span>
                                        </button>
                                        {this.state.showLanguagesBox && (
                                            <div ref={el => this.language_select_box = el} className="blur-back language-select-box fadein">
                                                {Object.values(languagesInfo).map((prop, index) => {
                                                    return (
                                                        <button key={index} className={" flexc language-select-option " + (index !== 0 ? "mt-3" : '')} onClick={() => this.changeLanguage('language', prop.shortName)}>
                                                            <img className="mrd-2" src={prop.icon} alt={"language-" + prop.name} />
                                                            <div>{prop.name}</div>
                                                        </button>
                                                    )
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )} */}

                            {/* <button className="flexcc mld-2 p-0 d-lg-none" onClick={() => this.setState({ showMoileMenu: true })}>
                            <img className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : ''} src="/images/menu.png" height="30px" alt="" />
                        </button> */}

                        </div>
                    </div>




                    {/* MOBILE MENU */}
                    {
                        this.state.showMoileMenu && (
                            <div className="w-100 blur-back d-lg-none" style={{ overflow: 'auto', height: 'calc(100vh)', backgroundColor: siteTheme.themeColors.headerBack + 'dd', position: 'fixed', top: 0, left: 0, zIndex: 1000 }}>

                                <button onClick={() => this.setState({ showMoileMenu: false })} style={{ position: 'absolute', top: 10, left: 10 }}>
                                    <img className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : ''} src="https://image.flaticon.com/icons/svg/748/748122.svg" width="25px" />
                                </button>

                                <div className="flexcc mt-5">
                                    <button onClick={() => this.setState({ showMoileMenu: false })}>
                                        <TLink pathname='/' className="flexcc">
                                            <img className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : ''} src={siteTheme.logo_s} height="45px" alt={siteConfig.name + ' logo'} />
                                        </TLink>
                                    </button>
                                </div>

                                <div className='flexcc flex-column text-center mt-4'>
                                    {routes.map((prop, index) => {
                                        if (prop.header) {
                                            if (this.checkPermission(prop, this.props.user)) {
                                                return (
                                                    <nav key={index} className="cursor-pointer  mb-4" onClick={() => this.setState({ showMoileMenu: false })}>
                                                        <TLink pathname={prop.pathForHeader ? prop.pathForHeader : prop.path} ><p className="text-semibig">{checkTextTranslation(prop.name)}</p></TLink>
                                                    </nav>
                                                )
                                            }
                                        } else {
                                            return
                                        }
                                    })}
                                </div>


                                {/* {siteConfig.showLanguage && (

                            <div className="flexcc ">

                                {languagesInfo[this.props.settings?.language] && (
                                    <div className="" style={{ position: 'relative' }}>
                                        <button onClick={() => this.toggleLanguagesBox()} className="flexcc language-but">
                                            <img className="" src={languagesInfo[this.props.settings?.language].icon} height="20px" alt="" />
                                            <span className=" mld-2" style={{ color: siteTheme.themeColors.headerFont }}>{languagesInfo[this.props.settings?.language].name}</span>
                                        </button>
                                        {this.state.showLanguagesBox && (
                                            <div ref={el => this.language_select_box = el} className="blur-back language-select-box fadein">
                                                {Object.values(languagesInfo).map((prop, index) => {
                                                    return (
                                                        <button key={index} className={" flexc language-select-option " + (index !== 0 ? "mt-3" : '')} onClick={() => this.changeLanguage('language', prop.shortName)}>
                                                            <img className="mrd-2" src={prop.icon} alt={"language-" + prop.name} />
                                                            <div>{prop.name}</div>
                                                        </button>
                                                    )
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )} */}

                            </div>


                        )
                    }

                </header >
            )
        } else {
            return (<div></div>)
        }
    }








}


const mapStateToProps = state => ({ settings: state.settings, cart: state.cart, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Header);

// export default Header

